module.exports = "/assets/ecs/lno/ecs-lno-frontend-concierge/3.4.9/_next/static/images/voce-sa-6e52ded18bdbf39e44b719f2f477cd7d.png";